/*
  ==================================================================
  CART PAGE UPSELL  |  The Weave Market
  File: assets/cart-upsell.js

  Adds an upsell product from the cart page without a reload, then
  re-renders Dawn's cart line items, cart footer, header cart bubble
  and the upsell row itself using the Section Rendering API.

  Mirrors the same section-replacement approach Dawn's own cart JS
  uses, so it stays consistent with the theme's behaviour.

  If JavaScript fails, the Add button falls back to a normal form
  POST to /cart/add, which reloads the cart page. Nothing breaks.
  ==================================================================
*/

(function () {
  'use strict';

  function addToCartUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  /*
    Builds the list of sections to refresh. Each entry mirrors Dawn's
    shape: `id` is the DOM element, `section` is the Shopify section id
    sent to the API, `selector` is the inner node whose HTML is swapped.
  */
  function getSectionsToRender(root) {
    var sections = [];

    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      sections.push({
        id: 'main-cart-items',
        section: cartItems.dataset.id,
        selector: '.js-contents'
      });
    }

    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      sections.push({
        id: 'main-cart-footer',
        section: cartFooter.dataset.id,
        selector: '.js-contents'
      });
    }

    if (document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      });
    }

    if (document.getElementById('cart-live-region-text')) {
      sections.push({
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      });
    }

    if (root && root.id && root.dataset.sectionId) {
      sections.push({
        id: root.id,
        section: root.dataset.sectionId,
        selector: '.cart-upsell__inner'
      });
    }

    return sections;
  }

  function sectionInnerHTML(html, selector) {
    if (!html) return null;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var node = parsed.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function renderSections(sections, payload) {
    sections.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host) return;

      var target = host.querySelector(section.selector) || host;
      var html = sectionInnerHTML(payload[section.section], section.selector);
      if (html !== null) target.innerHTML = html;
    });
  }

  function setLoading(button, isLoading) {
    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
  }

  function showError(root, message) {
    if (!root) return;
    var note = root.querySelector('.cart-upsell__error');
    if (!note) return;

    note.textContent = message;
    note.hidden = false;
  }

  function clearError(root) {
    if (!root) return;
    var note = root.querySelector('.cart-upsell__error');
    if (!note) return;

    note.textContent = '';
    note.hidden = true;
  }

  // Let Dawn's pub/sub listeners and any installed apps know the cart changed.
  function notifyTheme() {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
      }
    } catch (error) {
      /* pub/sub not present in this theme version */
    }
    document.dispatchEvent(new CustomEvent('cart-upsell:added', { bubbles: true }));
  }

  /*
    Delegated on document so it survives every section re-render.
    Listening for `submit` rather than `click` means the keyboard
    Enter key works and the no-JS form fallback stays intact.
  */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-upsell-form]');
    if (!form) return;

    event.preventDefault();

    var root = form.closest('cart-upsell');
    var card = form.closest('.cart-upsell__card');
    var button = form.querySelector('[data-cart-upsell-add]');
    var idField = form.querySelector('[name="id"]');
    var variantId = idField ? idField.value : null;

    if (!variantId) {
      showError(root, 'Choose an option before adding this item.');
      return;
    }

    if (button) setLoading(button, true);
    clearError(root);

    var sections = getSectionsToRender(root);
    var sectionIds = sections
      .map(function (section) {
        return section.section;
      })
      .filter(function (value, index, all) {
        return value && all.indexOf(value) === index;
      });

    fetch(addToCartUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify returns a `status` field only on errors, e.g. sold out.
        if (data.status || data.errors) {
          if (button) setLoading(button, false);
          showError(root, data.description || data.message || 'That item is unavailable right now.');
          return;
        }

        if (card) card.classList.add('is-added');

        if (data.sections) {
          renderSections(sections, data.sections);
        } else {
          window.location.reload();
          return;
        }

        notifyTheme();
      })
      .catch(function (error) {
        console.error('[cart-upsell]', error);
        if (button) setLoading(button, false);
        showError(root, 'Could not add that item. Please try again.');
      });
  });

  // Keep the displayed price in step with the chosen variant.
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cart-upsell-variants]');
    if (!select) return;

    var card = select.closest('.cart-upsell__card');
    if (!card) return;

    var option = select.options[select.selectedIndex];
    var priceEl = card.querySelector('.cart-upsell__price-now');
    if (priceEl && option && option.dataset.price) {
      priceEl.textContent = option.dataset.price;
    }
  });
})();
